<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [dialogMsgSupplier]="null" [width]="800"></yo-help>
    </div>
  </dxi-item>
  <dxi-item location="before"  class="mg-l-5 mg-r-5">
    <yo-button
      class="mg-r-10"
      iconClass="fa fa-plus"
      [theme]="ButtonThemeEnum.ADD"
      label="CRÉER"
      tooltip="Créer un regroupement de plat"
      (click)="createRougrepemntPlat()"
    >
    </yo-button>
  </dxi-item>
  <dxi-item location="after" class="mg-r-16">
    <yo-button
      iconClass="fas fa-trash"
      [theme]="ButtonThemeEnum.DELETE"
      (onClick)="deleteValues()"
      tooltip="Supprimer les éléments sélectionnés">
    </yo-button>
  </dxi-item>
</dx-toolbar>
<div class="container-table">
  <dx-data-grid
    [dataSource]="regroupements"
    keyExpr="id"
    width="100%"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="true"
    [showRowLines]="true"
    [showBorders]="true"
    [(selectedRowKeys)]="selectedRows">
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxi-column dataField="id" caption="Actions"
                [allowFiltering]="false"
                [allowGrouping]="false"
                [allowEditing]="false"
                [alignment]="'left'"
                [width]="90"
                cellTemplate="actionsCellTemplate">
    </dxi-column>

    <dxi-column dataField="libelle" caption="Nom"
                [allowEditing]="false"
                [allowFiltering]="true"
                [allowSearch]="true">
    </dxi-column>
    <dxi-column dataField="site" caption="Site"
                [allowFiltering]="true"
                [allowGrouping]="false"
                [allowSearch]="true"
                cellTemplate="siteCellTemplate">
    </dxi-column>
    <dxi-column dataField="uniteDeProduction" caption="Unités de production"
                [allowFiltering]="true"
                [allowGrouping]="false"
                [allowSearch]="true"
                cellTemplate="udpCellTemplate">
    </dxi-column>
    <dxo-selection [allowSelectAll]="true" showCheckBoxesMode="always"
                   mode="multiple"></dxo-selection>
    <dxo-editing mode="cell" [allowUpdating]="true" [confirmDelete]="false"></dxo-editing>

    <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container" >
      <yo-button
        size="small"
        [iconClass]="'fa fa-edit'"
        [theme]="ButtonThemeEnum.DEFAULT_INNER"
        [tooltip]="'Consulter la facture'"
        [disabled]="false"
        (onClick)="editRegroupement(cell.row.data.id)">
      </yo-button>
    </div>

    <div *dxTemplate="let cell of 'siteCellTemplate'">
      <yo-site [siteId]="cell.row.data.site.id" [siteLibelleTooltip]="cell.row.data.site.libelle"
               [siteLibelle]="cell.row.data.site.libelle"></yo-site>
    </div>

    <div *dxTemplate="let cell of 'udpCellTemplate'">
      <div *ngFor="let udp of cell.data.uniteDeProduction">
        {{ udp.libelle }}
      </div>
    </div>

    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} facture(s)">
    </dxo-pager>
  </dx-data-grid>
</div>
<router-outlet></router-outlet>
